if (!customElements.get('cart-footer-cross-sell')) {
  customElements.define(
    'cart-footer-cross-sell',
    class CartFooterCrossSell extends HTMLElement {
      constructor() {
        super();

        this.cartUpdateUnsubscriber = undefined;

        // 多卡片共用一个列表 ID，Core 根据当前 DOM 顺序生成每张卡片的 index。
        this.core = new window.CartCrossSellCore(this, {
          source: this.dataset.cartSource || 'cart-footer-cross-sell',
          refreshTargetPrefix: this.dataset.refreshTargetPrefix || 'MainCartFooterCrossSell-',
          replaceCartRoots: this.hasAttribute('data-replace-cart-roots'),
          tracking: {
            itemListId: this.dataset.itemListId || 'cart_cross_sell_multi',
            itemListName: this.dataset.itemListName || 'Cart Cross Sell Multi',
            cardSelector: '[data-cart-cross-sell-card]',
            titleSelector: this.dataset.titleSelector || '.cart-footer-cross-sell__title',
          },
        });

        // 使用组件级事件代理处理动态生成的多张 ADD 按钮。
        this.addEventListener('click', this.onSubmit.bind(this));
      }

      connectedCallback() {
        // 为每张多卡片开启有效曝光，并监听卡片内商品链接点击。
        this.core.connectTracking();

        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event?.source === this.core.source) return;

          this.core.refresh();
        });
      }

      disconnectedCallback() {
        // 组件被 section 局部刷新替换时释放埋点与购物车订阅。
        this.core.disconnectTracking();

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      async onSubmit(event) {
        const eventTarget = event.target instanceof Element ? event.target : null;
        const button = eventTarget?.closest('[data-cart-cross-sell-submit]');
        if (!button || !this.contains(button)) return;

        event.preventDefault();

        if (button.getAttribute('aria-disabled') === 'true') return;

        // 从实际点击按钮定位所属卡片，保证错误提示、index 和商品归因一致。
        const card = button.closest('[data-cart-cross-sell-card]');
        const buttonText = button.querySelector('[data-cart-cross-sell-button-text]');
        const errorElement = card?.querySelector('[data-cart-cross-sell-error]');
        const variantId = button.dataset.variantId;

        if (!variantId) {
          this.handleErrorMessage(errorElement, window.cartStrings?.error || 'Missing product information.');
          return;
        }

        // 加购前保存商品与卡位快照，后续 DOM 刷新不会改变本次事件归因。
        const trackingItem = this.core.getTrackingItem(button);

        this.setLoading(button, buttonText, true);
        this.handleErrorMessage(errorElement);

        try {
          const parsedState = await this.core.addRecommendationToCart(variantId);

          if (!parsedState || parsedState.status) {
            this.handleErrorMessage(errorElement, parsedState?.description || parsedState?.message || window.cartStrings?.error || 'Something went wrong. Please try again.');
            return;
          }

          // 只有 Shopify 明确返回成功结果时才发送关联销售加购事件。
          this.core.trackSuccessfulAdd(trackingItem);

          this.core.renderSections(parsedState.sections || {});
          this.core.publishCartUpdate(parsedState, variantId);
        } catch (error) {
          console.error(error);
          this.handleErrorMessage(errorElement, window.cartStrings?.error || 'Something went wrong. Please try again.');
        } finally {
          this.setLoading(button, buttonText, false);
        }
      }

      setLoading(button, buttonText, isLoading) {
        if (!button) return;

        button.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
        button.classList.toggle('is-loading', isLoading);

        if (buttonText) {
          if (!buttonText.dataset.originalText) {
            buttonText.dataset.originalText = buttonText.textContent;
          }

          buttonText.textContent = isLoading ? buttonText.dataset.loadingText || buttonText.dataset.originalText : buttonText.dataset.originalText;
        }
      }

      handleErrorMessage(errorElement, message = '') {
        if (!errorElement) return;

        errorElement.textContent = message;
        errorElement.toggleAttribute('hidden', !message);
      }
    }
  );
}
